import React from "react";
import {
  ApiOutlined,
  AppstoreOutlined,
  BarChartOutlined,
  CloudServerOutlined,
  CodeOutlined,
  DatabaseOutlined,
  FundOutlined,
  RocketOutlined,
  SafetyCertificateOutlined,
  ToolOutlined,
} from "@ant-design/icons";

export interface InternalAppItem {
  key: string;
  title: string;
  description: string;
  icon: React.ReactNode;
  href: string;
}

interface InternalAppGroup {
  label: string;
  featuredItems: InternalAppItem[];
  otherItems: InternalAppItem[];
}

export const INTERNAL_APP_GROUP: InternalAppGroup = {
  label: "内网应用",
  featuredItems: [
    {
      key: "digitalTwinCenter",
      title: "高仙数字分身中心",
      description: "数字分身、workspace、skills 与 sessions 管理平台",
      icon: <AppstoreOutlined />,
      href: "https://dt.ai.gsbot.dev",
    },
    {
      key: "robotOtaMonitor",
      title: "机器人OTA监控",
      description: "机器人 OTA 升级批次监控与执行结果分析",
      icon: <CloudServerOutlined />,
      href: "https://ota-m.ai.gsbot.dev",
    },
    {
      key: "taskImages",
      title: "任务图片",
      description: "机器人任务图片查看与管理",
      icon: <DatabaseOutlined />,
      href: "https://fe-task-cameras-management-wangxin.ai.gsbot.dev",
    },
    {
      key: "gsPromptUpdate",
      title: "GS 提示词更新",
      description: "提示词查找、复用和维护平台",
      icon: <CodeOutlined />,
      href: "https://prompt-lan.ai.gsbot.dev",
    },
  ],
  otherItems: [
    {
      key: "internalKnowledgeAssistant",
      title: "高仙内AI知识库助手",
      description: "高仙内部 AI 知识查询助手",
      icon: <ApiOutlined />,
      href: "https://metis.ai.gsbot.dev",
    },
    {
      key: "factoryHotfix",
      title: "工厂参数热修",
      description: "工厂设备维护人员参数热修工具",
      icon: <ToolOutlined />,
      href: "https://factory-hotfix.ai.gsbot.dev",
    },
    {
      key: "robotTaskAnalysis",
      title: "机器人任务分析",
      description: "机器人任务数据分析与问题排查工具",
      icon: <BarChartOutlined />,
      href: "https://kbs-m.ai.gsbot.dev",
    },
    {
      key: "internalDeploymentCenter",
      title: "内网应用部署中心",
      description: "内网应用部署与资源管理工具",
      icon: <CloudServerOutlined />,
      href: "https://panel.ai.gsbot.dev",
    },
    {
      key: "wecomMessageMonitor",
      title: "企业微信消息监控",
      description: "企业微信业务消息监控工具",
      icon: <SafetyCertificateOutlined />,
      href: "https://wecom-m.ai.gsbot.dev",
    },
    {
      key: "afterSalesTicketAnalysis",
      title: "售后工单分析中心",
      description: "售后工单数据分析平台",
      icon: <FundOutlined />,
      href: "https://themis.ai.gsbot.dev",
    },
    {
      key: "gaussianAiWorkbench",
      title: "Gaussian AI 工作台",
      description: "Gaussian AI 内部工作台",
      icon: <RocketOutlined />,
      href: "https://talos-peihaojun.ai.gsbot.dev",
    },
    {
      key: "wikiBenchmark",
      title: "Wiki benchmark 测试平台",
      description: "GaussianWIKI 与内部应用知识库测试平台",
      icon: <DatabaseOutlined />,
      href: "https://argus.ai.gsbot.dev",
    },
  ],
};
